import React from 'react'
import PropTypes from 'prop-types'
import Icon from 'components/Icon'
import Loader from 'components/Loader'
import Submit from './Submit'

export default class MarketingChannels extends React.Component {
  static propTypes = {
    channels: PropTypes.array,
    submitButtonText: PropTypes.string,
    onSubmit: PropTypes.func,
    onSkip: PropTypes.func,
    queryError: PropTypes.string,
    embedded: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
  }

  render() {
    const {channels, embedded} = this.props

    if (!channels) {
      return (
        <div className='marketing-channels'>
          <Loader />
        </div>
      )
    }

    return (
      <div className='marketing-channels'>
        {channels.map(({channelGroupId, channelId, icon, bg, title, authorizationURL, connected}, index) => (
          <div className='marketing-channels_item' key={index}>
            <div className='marketing-channels_item_title'>
              <div className='marketing-channels_item_bg' style={{background: bg}}>
                <Icon name={icon} size='28px' />
              </div>
              <div className='marketing-channels_item_text'>
                {title}
              </div>
            </div>
            <div className='marketing-channels_item_action'>
              {connected
                ? <div className='marketing-channels_item_connected'>
                  <Icon name='tick' size='13px' height='10px' />
                </div>
                : <a
                  className='marketing-channels_item_button button is-blue'
                  href={authorizationURL}
                  target={embedded ? '_blank' : '_self'}
                >
                  Connect
                </a>
              }
            </div>
          </div>
        ))}
        <p className='wizard_step_text'>
          You will be able to integrate costs for all other channels after finishing the setup wizard
        </p>
        {this.renderActions()}
      </div>
    )
  }

  renderActions() {
    const {channels, submitButtonText, onSubmit, onSkip} = this.props
    const hasConnectedChannels = channels.find(channel => channel.connected)

    return (
      <div className='marketing-channels_action'>
        {this.renderError()}
        <Submit onClick={onSubmit} disabled={!hasConnectedChannels}>{submitButtonText}</Submit>
        {hasConnectedChannels
          ? null
          : <div onClick={onSkip} className='marketing-channels_skip'>Skip for now</div>
        }
      </div>
    )
  }

  renderError() {
    const {queryError} = this.props

    if (!queryError) return null

    return (
      <div className='marketing-channels_error'>
        Marketing channel connection failed with an error: {queryError}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/Wizard/MarketingChannels.js